import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used on Leesona 861 FC and 861 Tackified machines

export default function BeginTensionRow() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <Row className="mb-2">
         <ColPrompt title={"Beginning Tension"} bold={true} description={"g"} />
         <ColValue size={2}>
            Min:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.begTensionMin || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 600, "begTensionMin")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 600, "begTensionMin")
               }
            />
            {errorDivDefinitions.begTensionMin && (
               <ErrorDiv>0-600 only</ErrorDiv>
            )}
         </ColValue>
         <ColValue size={2}>
            Max:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.begTensionMax || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 600, "begTensionMax")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 600, "begTensionMax")
               }
            />
            {errorDivDefinitions.begTensionMax && (
               <ErrorDiv>0-600</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}
